var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cartx-b-close-preview-icon cartx-b-close-v2-svg",class:("cartx-b-close-preview-icon--" + _vm.bgMode),style:(_vm.wrapperStyle),domProps:{"innerHTML":_vm._s(_vm.svgContent)}})}
var staticRenderFns = []

export { render, staticRenderFns }